// src/components/ProjectModal.js
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { X } from "lucide-react";

const ProjectModal = ({ project, isOpen, onClose }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  console.log('ProjectModal render:', { isOpen, project: project?.title });

  useEffect(() => {
    if (isOpen) {
      // Pequeño delay para activar la transición
      setTimeout(() => setIsVisible(true), 10);
    } else {
      setIsVisible(false);
    }
  }, [isOpen]);

  if (!isOpen || !project) {
    console.log('Modal no renderizado:', { isOpen, hasProject: !!project });
    return null;
  }

  const images = project.images.gallery || [project.images.main];
  console.log('Modal renderizando con imágenes:', images.length);

  const handleThumbnailClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      setIsVisible(false);
      setTimeout(() => onClose(), 600); // Esperar a que termine la transición
    }
  };

  const handleCloseClick = () => {
    setIsVisible(false);
    setTimeout(() => onClose(), 600); // Esperar a que termine la transición
  };

  const modalContent = (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        backgroundColor: `rgba(0, 0, 0, ${isVisible ? 1 : 0})`,
        display: 'flex',
        transition: 'background-color 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
        opacity: isVisible ? 1 : 0
      }}
      onClick={handleOverlayClick}
    >
      {/* Close Button */}
      <button
        onClick={handleCloseClick}
        style={{
          position: 'absolute',
          top: '2rem',
          right: '2rem',
          zIndex: 10000,
          color: 'rgba(255, 255, 255, 0.7)',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'scale(1)' : 'scale(0.8)'
        }}
        onMouseEnter={(e) => e.currentTarget.style.color = 'white'}
        onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}
        aria-label="Cerrar modal"
      >
        <X size={32} strokeWidth={1.5} />
      </button>

      {/* Main Content Container */}
      <div style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
        transform: isVisible ? 'scale(1)' : 'scale(0.95)',
        opacity: isVisible ? 1 : 0
      }}>
        {/* Thumbnail Column - 10% (IZQUIERDA) */}
        <div style={{
          width: '10vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          overflowY: 'auto',
          overflowX: 'hidden',
          padding: '2vh 1vw',
          transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
          transform: isVisible ? 'translateX(0)' : 'translateX(-100%)',
          boxSizing: 'border-box',
          backdropFilter: 'blur(10px)'
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5vh' }}>
            {images.map((image, index) => (
              <button
                key={index}
                onClick={() => handleThumbnailClick(index)}
                style={{
                  position: 'relative',
                  width: '100%',
                  aspectRatio: '1',
                  overflow: 'hidden',
                  transition: 'all 0.3s',
                  opacity: currentImageIndex === index ? 1 : 0.5,
                  border: currentImageIndex === index ? '2px solid white' : 'none',
                  cursor: 'pointer',
                  background: 'none',
                  padding: 0,
                  boxSizing: 'border-box'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.75'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = currentImageIndex === index ? '1' : '0.5'}
              >
                <img
                  src={image}
                  alt={`Miniatura ${index + 1}`}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                />
              </button>
            ))}
          </div>
        </div>

        {/* Main Image - 90% (DERECHA) */}
        <div style={{
          width: '90vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#000',
          transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
          transform: isVisible ? 'translateX(0)' : 'translateX(100%)',
          overflow: 'hidden'
        }}>
          <img
            src={images[currentImageIndex]}
            alt={`${project.title} - ${currentImageIndex + 1}`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              transition: 'opacity 0.3s ease',
              display: 'block'
            }}
          />
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(
    modalContent,
    document.body
  );
};

export default ProjectModal;
